<template>
    <div>
        <el-button @click="drawerVisible = true" class="show-filter-btn">
            <img src="@/assets/icons/filter.png" alt="filter-icon" width="14" />
            <span v-if="arrangeRadio || filterRadio" class="noti-badge"></span>
        </el-button>
        <el-drawer
            :visible="drawerVisible"
            @close="drawerVisible = false"
            direction="rtl"
            :show-close="false"
            class="filter-drawer"
        >
            <aside class="filter-side">
                <main>
                    <header class="header">
                        <h1 class="x-btn" @click="drawerVisible = false">
                            <i class="el-icon-close"></i>
                        </h1>
                        <h1 class="topic">
                            {{ $t('home-deal.topic') }}
                        </h1>
                    </header>

                    <div class="filter-article">
                        <legend class="filter-legend">
                            <img
                                src="@/assets/icons/arrange.png"
                                alt="filter-icon"
                                width="14"
                            />
                            {{ $t('home-deal.arrange') }}
                        </legend>
                        <el-radio-group v-model="arrangeRadio">
                            <el-radio
                                v-for="item in arrangeOptions"
                                :key="item"
                                :label="item"
                                >{{
                                    $t(`home-deal.arrange-op${item}`)
                                }}</el-radio
                            >
                        </el-radio-group>

                        <legend class="filter-legend">
                            <img
                                src="@/assets/icons/filter.png"
                                alt="filter-icon"
                                width="14"
                            />
                            {{ $t('home-deal.filter') }}
                        </legend>
                        <el-radio-group v-model="filterRadio">
                            <el-radio
                                v-for="item in filterOptions"
                                :key="item"
                                :label="item"
                                style="display: flex;"
                                >{{
                                    $t(`home-deal.filter-op${item}`)
                                }}</el-radio
                            >
                        </el-radio-group>
                    </div>
                </main>

                <footer
                    style="
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                    "
                >
                    <el-button
                        class="footer-btn apply-btn filter-drawer"
                        @click="handleBeforeApply"
                        >{{ $t('home-deal.apply') }}</el-button
                    >
                    <el-button class="footer-btn filter-drawer" @click="resetRadio">{{
                        $t('home-deal.reset')
                    }}</el-button>
                </footer>
            </aside>
        </el-drawer>
    </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'

export default {
    props: {},
    data() {
        return {
            drawerVisible: false,
            arrangeRadio: null,
            filterRadio: null,
            arrangeOptions: [1, 2, 3, 4, 5],
            filterOptions: [1, 2, 3],
        }
    },
    methods: {
        ...mapMutations({
            SET_PROMOTION_FILTER: 'promotion/SET_PROMOTION_FILTER',
            SET_PROMOTION_SORT: 'promotion/SET_PROMOTION_SORT',
            fetchPromotionList: 'promotion/fetchPromotionList',
        }),

        resetRadio() {
            this.arrangeRadio = null
            this.filterRadio = null
            this.SET_PROMOTION_FILTER(this.defaultPromotionList)
        },
        handleBeforeApply() {
            if (this.arrangeRadio && this.filterRadio) {
                this.filterPromotions({sorting: true})
            } else {
                this.arrangeRadio && this.sortPromotions()
                this.filterRadio && this.filterPromotions({sorting: false})
            }
            this.drawerVisible = false
        },

        filterPromotions(options = { sorting: false }) {
            let filteredPromotions
            switch (this.filterRadio) {
                case 2: //Free point pro
                    filteredPromotions = this.defaultPromotionList.filter(
                        (pro) => pro.point == 0
                    )
                    break;
                case 3: //Use point pro
                    filteredPromotions = this.defaultPromotionList.filter(
                        (pro) => pro.point != 0
                    )
                    break;
                default: //case 1 -> do nothing
                    filteredPromotions = this.defaultPromotionList
                    break;
            }

            if (!options.sorting) {
                this.SET_PROMOTION_FILTER(filteredPromotions)
            } else {
                this.sortPromotions(filteredPromotions)
            }
        },
        sortPromotions(promotionList = this.defaultPromotionList) {
            // collator is used for locale and sensitivity level, ensuring proper language sorting
            const activeLanguage = `${
                this.$i18n.locale
            }-${this.$i18n.locale.toUpperCase()}`
            const collator = new Intl.Collator(activeLanguage, {
                sensitivity: 'base',
            })

            let sortedPromotions
            switch (this.arrangeRadio) {
                case 1: //Point low - hight
                    sortedPromotions = promotionList.sort(
                        (a, b) => a.point - b.point,
                    )
                    this.SET_PROMOTION_SORT(sortedPromotions)
                    break
                case 2: //Point high - low
                    sortedPromotions = promotionList.sort(
                        (a, b) => b.point - a.point,
                    )
                    this.SET_PROMOTION_SORT(sortedPromotions)
                    break
                case 3: //End date and time is closer
                    sortedPromotions = promotionList.sort((a, b) => {
                        const dateComparison = a.endDate.localeCompare(
                            b.endDate,
                        )
                        return dateComparison !== 0
                            ? dateComparison
                            : a.endTime.localeCompare(b.endTime)
                    })
                    this.SET_PROMOTION_SORT(sortedPromotions)
                    break
                case 4: //ก - ฮ, A - Z
                    sortedPromotions = promotionList.sort((a, b) =>
                        collator.compare(a.name, b.name),
                    )
                    this.SET_PROMOTION_SORT(sortedPromotions)
                    break
                case 5: //ฮ - ก, Z - A
                    sortedPromotions = promotionList.sort((a, b) =>
                        collator.compare(b.name, a.name),
                    )
                    this.SET_PROMOTION_SORT(sortedPromotions)
                    break
                default:
                    break
            }
        },
    },
    computed: {
        ...mapGetters({
            promotionList: 'promotion/promotionList',
            defaultPromotionList: 'promotion/defaultPromotionList',
            branchUUID: 'branch/branchUUID',
        }),
    },
}
</script>

<style scoped>
.filter-drawer {
    font-family: 'DB Heavent', sans-serif;
}
.filter-side {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.el-button {
    padding: 10px 12px;
}
::v-deep .filter-drawer .el-drawer__header {
    margin-bottom: 0;
}
.header {
    display: flex;
    margin-left: 15px;
}
.header h1 {
    margin: 0;
    font-size: 24px;
    font-weight: lighter;
}

@media (max-width: 900px) {
    ::v-deep .filter-drawer .el-drawer {
        width: 80% !important;
    }
}

::v-deep .filter-drawer .el-radio-group {
    display: flex;
    flex-direction: column;
    margin-left: 11px;
}

::v-deep .filter-drawer .el-radio__input {
    position: relative;
    margin-bottom: 12px;
}

::v-deep .filter-drawer .el-radio__input.is-checked .el-radio__inner {
    background-color: var(--primary);
}

.footer-btn {
    width: 90%;
    margin-bottom: 18px;
    font-size: 20px;
}

.show-filter-btn {
    position: relative;
}
.noti-badge {
    position: absolute;
    top: 0;
    right: 0;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: var(--primary);
}

.filter-article {
    margin: 20px;
}
.filter-article img {
    margin-right: 6px;
}
.filter-legend {
    margin-bottom: 15px;
    border-radius: 10px;
    background-color: #f6f8fa;
    padding: 10px;
    font-size: 18px;
}
.apply-btn {
    background-color: var(--primary);
    color: white;
}
.x-btn {
    width: 15%;
    height: 3px;
}
.topic {
    width: 85%;
    margin-left: 16px;
}

.el-radio {
    display: flex;
}

::v-deep .filter-drawer .el-radio__label {
    font-size: 16px;
}
</style>
